import 'Site/scss/page.header.scss';
import store from 'Site/js/store';
import MapAndList from 'Location/component/MapAndList.vue';
import { mapState } from 'vuex';
import Vue from 'vue';

export default function () {

    new Vue({ /* eslint no-new: 0 */
        el: '#page-body',
        name: 'profilesMap',
        store,
        components: {
            MapAndList
        },
        computed: {
            ...mapState(['config']),
            filteredLocations() {
                return this.config.data.locations.filter(location => location.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);
            }
        },
        data() {
            return {
                searchTerm: ''
            };
        }
    });
}
